import analytics from "fond/analytics";
import { inputLayerGroups } from "fond/layers";
import { beginEditing, deleteLayerFeatures, EditMode, repositionHubs, revertHubs, setEditMode } from "fond/project/redux";
import { LayerIds } from "fond/types";
import { useAppDispatch } from "fond/utils/hooks";
import { useStackedNavigationContext } from "fond/widgets";

/**
 * Actions for refining a completed design.
 */
export const useDesignRefinementActions = () => {
  const { open } = useStackedNavigationContext();
  const dispatch = useAppDispatch();

  const moveHubs = ({ resetDropAssignments }: { resetDropAssignments: boolean }) => {
    if (resetDropAssignments) {
      dispatch(deleteLayerFeatures([LayerIds.dropAssignment], "move-hubs"));
    }
    dispatch(repositionHubs());
    open("draw");
  };

  const editDropAssignments = () => {
    analytics.track("Clicked edit drop assignments");
    dispatch(beginEditing(inputLayerGroups.dropAssignments.id));
    dispatch(setEditMode(EditMode.edit));
    open("draw");
  };

  const resetEdits = () => {
    analytics.track("Clicked reset moved equipment");
    dispatch(revertHubs());
  };

  return { moveHubs, editDropAssignments, resetEdits };
};
